module.exports = __webpack_public_path__ + "img/DSC_0099.0ee53783.jpg";